import { create } from 'zustand';
import { immerMiddleware } from '../services/Utils';

const chatsStore = () => ({
  replyChat: null
});

export const useChatsStore = create(immerMiddleware(chatsStore));
